var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12592_9764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4219 3.5362C13.3692 3.48756 13.298 3.45954 13.2232 3.45801C13.1468 3.45927 13.0737 3.48723 13.0189 3.5362L7.84764 8.29046C7.79432 8.33766 7.72303 8.36385 7.64897 8.36345C7.57317 8.36412 7.5 8.33798 7.44462 8.29046L6.2923 7.2218C6.23898 7.1746 6.16768 7.14841 6.09362 7.14882C6.01783 7.14814 5.94466 7.17428 5.88927 7.2218L4.75398 8.29046C4.72683 8.31386 4.70519 8.34213 4.69039 8.37351C4.6756 8.40489 4.66797 8.43872 4.66797 8.47292C4.66797 8.50711 4.6756 8.54095 4.69039 8.57233C4.70519 8.60371 4.72683 8.63197 4.75398 8.65537L7.42759 11.1576C7.4816 11.2057 7.55387 11.2326 7.6291 11.2326C7.70433 11.2326 7.7766 11.2057 7.83062 11.1576L14.5799 4.96978C14.6065 4.94555 14.6276 4.91672 14.642 4.88496C14.6565 4.85319 14.6639 4.81913 14.6639 4.78472C14.6639 4.75031 14.6565 4.71624 14.642 4.68448C14.6276 4.65271 14.6065 4.62389 14.5799 4.59966L13.4219 3.5362Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12592_9764",
    x: 0.886246,
    y: 0.621716,
    width: 17.5595,
    height: 15.3379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.945431
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89086
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12592_9764"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12592_9764",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.7feb4137705983bc4c67a67012fbe5cb.svg";
export { ForwardRef as ReactComponent };